/**
 * @module Core
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

/* tslint:disable:  max-line-length*/ // API const file
// The solution discussed in the call of using `` is not working on breaking api endpoints to different line

/**
 * API Map for resolving API endpoints
 * @access public - global
 */
// @TODO fix the lint issues (max length)
// @TODO alot of these exist in common-api-endpoints (maybe Object.assign?)
export const WEB_API_MAP = {
  ANON_TOKEN_API: {
    domain: 'esGatewayEndpoint',
    name: 'ANON_TOKEN_API',
    proxyName: 'web-auth',
    url: 'anonymous-token-jwt'
  },
  API_999_getCustomerProfile: {
    domain: 'TAGEndpoint',
    name: 'API_999_getCustomerProfile',
    proxyName: 'customer-manage-profile',
    url: 'self-service-tpp-customer-manage-profile/v1/customer-profile-jwt',
    is_tag_proxy: true

  },
  API_2235_validatePinForOwnership: {
   domain: 'TAGEndpoint',
   name: 'API_2235_validatePinForOwnership',
   proxyName: 'web-auth',
   url: 'self-service-tpp-web-auth/v1/auth/customerVerify',
   is_tag_proxy: true
 },
  API_521_userLogOut: {
    domain: 'TAGEndpoint',
    name: 'API_521_userLogOut',
    proxyName: 'customer-manage-profile',
    url: 'self-service-tpp-customer-manage-profile/v1/logout',
    is_tag_proxy: true
  },
  API_452_postIdentityQuestions: {
    domain: 'TAGEndpoint',
    name: 'API_452_postIdentityQuestions',
    proxyName: 'utility',
    url: 'self-service-tpp-utility/v1/utility/identity-questions',
    is_tag_proxy: true
  },
  API_453_postValidateIdentityAnswers: {
    domain: 'TAGEndpoint',
    name: 'API_453_postValidateIdentityAnswers',
    proxyName: 'utility',
    url: 'self-service-tpp-utility/v1/utility/identity-validation',
    is_tag_proxy: true
  },
  API_2828_postEbbEnrollment: {
    domain: 'TAGEndpoint',
    name: 'API_2828_postEbbEnrollment',
    proxyName: 'utility',
    url: 'self-service-tpp-utility/v1/ebbEnrollment',
    is_tag_proxy: true
  },
  ANON_TOKEN_API_V6: {
    domain: 'esGatewayEndpoint',
    name: 'ANON_TOKEN_API',
    proxyName: '',
    url: 'oauth2/v6/tokens'
  },
  ANON_TOKEN_API_V1: {
    domain: 'TAGTokenEndpoint',
    name: 'ANON_TOKEN_API',
    proxyName: '',
    url: 'oauth2/v1/tokens'
  },
  AUTH_TOKEN_API_V1:{
    domain: 'TAGEndpoint',
    name: 'AUTH_TOKEN_API',
    proxyName: 'oauth-manager',
    url: 'self-service-tpp-oauth-manager/v1/oauth/token'
  },
  API_2240_setDNS: {
    domain: 'TAGEndpoint',
    name: 'API_2240_setDNS',
    proxyName: 'customer-manage-profile',
    url: 'self-service-tpp-customer-manage-profile/v1/setDns',
    is_tag_proxy: true
  }
};
